import { render } from "./ApplicationPage.vue?vue&type=template&id=8a10dc80"
import script from "./ApplicationPage.vue?vue&type=script&lang=js"
export * from "./ApplicationPage.vue?vue&type=script&lang=js"

import "./ApplicationPage.vue?vue&type=style&index=0&id=8a10dc80&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__